<script>
  import Container from '@/library/container/full-centre.svelte';
</script>

<style>
  .gradient {
    --start: rgba(28, 25, 23, 0.63);
    --end: rgba(41, 37, 36, 0.63);
    background-image: linear-gradient(109.6deg, var(--start) 18%, var(--end) 72%);
  }
</style>

<div class="z-40 absolute h-screen w-full gradient">
  <Container>
    <slot></slot>
  </Container>
</div>